<template >
	<div :style="globalElevatorOpen ? 'position: absolute; left:-4px; top: 50%; z-index: 1;' : 'position: absolute; left:-50px; top: 50%; z-index: 2;'">
		<v-btn class="rotateButton" style="background-color: lightgrey; "
				@click="toggleOpenElevator">
			<v-icon 
				
				style="position: relative; top: 8px;">{{globalElevatorOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
			</v-icon>
		</v-btn>
	</div>
</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
name: 'GlobalElevatorOpener',
data () {
	return {}
},

computed: {
	...mapState({   	}),

	globalElevatorOpen: {
        get () {
          return this.$store.state.ui.globalElevatorOpen
        },
        set (value) {
            this.updateGlobalElevator(!this.$store.state.ui.globalElevatorOpen)
        }
    },
},

methods : {
	...mapMutations([ 	'updateGlobalElevator',	'updatePhoneSearch'					]),

	toggleOpenElevator: function () {
		this.updateGlobalElevator(!this.globalElevatorOpen)
		this.updatePhoneSearch(null)
	},

},

}

</script>

<style>
.rotateButton {
	transform: rotate(-90deg);
}

.collapseIcon {
	border-style: solid;
	border-radius: 20px;
	border-width: 1px;
	border-color: #00000055;
	background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalElevatorOpener.vue